import React, { useContext, useMemo } from "react";

import { OrganizationContext } from "../../../routes/organization/OrganizationRoot";
import { AccountActivationMessage } from "../../messages/AccountActivationMessage";
import { Page } from "../../page/Page";

export const RestrictedOrgRoute = ({ hasValidSubscription, element }) => {
    const { org, orgRole, orgAccount } = useContext(OrganizationContext);
    const isActiveAccount = useMemo(() => orgAccount && orgAccount.isActive, [orgAccount]);

    if (!orgAccount) {
        return null;
    } else if (!hasValidSubscription || isActiveAccount) {
        return element;
    } else {
        return (
            <Page>
                <AccountActivationMessage
                    account={orgAccount}
                    accountRole={orgRole}
                    accountName={org.name}
                    manageSubscriptionLink={`/org/${org.id}/subscription`}
                    chooseSubscriptionLink={`/org/${org.id}/subscription/choose`}
                />
            </Page>
        );
    }
};
